/**
 * アプリケーションヘッダーコンポーネント
 */

import { useTranslation } from 'react-i18next';
import { Box, Heading, IconButton, Image } from '@chakra-ui/react';
import { HamburgerIcon } from '@/components/icons';

interface AppHeaderProps {
  onToggleSidebar: () => void;
}

export const AppHeader = ({ onToggleSidebar }: AppHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Box
      as="header"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent={{ base: 'flex-start', md: 'center' }}
      gap={2}
      borderBottom="1px solid"
      borderColor="borders.subtle"
      bg="white"
      px={{ base: 3, md: 6 }}
      py={5}
      boxShadow="sm"
    >
      <Box
        position={{ base: 'static', md: 'absolute' }}
        left={6}
        display="flex"
        alignItems="center"
        gap={2}
      >
        <Image
          src="/digitane-header.png"
          alt="Digitane Logo"
          w={10}
          h={10}
          objectFit="contain"
        />
        <IconButton
          aria-label={t('sidebar.toggle')}
          onClick={onToggleSidebar}
          display={{ base: 'flex', md: 'none' }}
          variant="ghost"
          color="gray.700"
        >
          <HamburgerIcon width={24} height={24} />
        </IconButton>
      </Box>
      <Box display="flex" maxW={200} alignItems="center" justifyContent="center">
        <Heading
          as="h1"
          m={0}
          fontSize={{ base: 'md', md: '2xl' }}
          fontWeight="bold"
          letterSpacing="tight"
          color="gray.700"
        >
          {t('app.name')}
        </Heading>
      </Box>
    </Box>
  );
};
